// const url = 'http://10.1.76.126:5000';
// export const url = 'http://10.1.76.169:5000';

export const url =
    process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';
// export const url = 'http://124.123.17.13:5000';

const Apiconfig = {
    auth: {
        login: `/auth/login-admin`,
        register: `/auth/register`,
        multiRegister: `/auth/multi/register`,
        generateHeaders: `/auth/generateHeaders`,
    },
    password: {
        forgetPassword: `${url}/user/forgetPassword`,
        resetPassword: `${url}/user/resetPassword`,
    },
    course: {
        getAllCourse: `/course/getAllCourses/`,
        getCourse: `/course/getCourse`,
        getCourseModule: `/lecture/allLecturesOfsection/`,
        createCourse: `/course/createCourse`,
        getScoreOfCourseofParticularStudent: `/course/courseScore`,
        uploadCourseContent: `/course/editCourse`,
        instructorRecentCourses: `/course/instructorRecentCourses`,
        editCourse: `/course/editCourse`,
        getCourseByMajorCategory: `/course/getCourseByMajorCategory`,
        addToRecent: `/course/recentlyStudied`,
        totalAssignmentsOfParticularCourseOfInstructor: `/course/totalAssignmentsOfParticularCourseOfInstructor`,
        getCourseProgress: `/course/getCourseProgress`,
        allCoursesofInstructor: `/course/coursesOfInstructor`,
        studentCoursePagination: `/course/getAllEnrolledCourses`,
        addToRecentlyDeleted: `/course/addToRecentlyDeleted`,
        deleteCourse: `/course/deleteCourse`,
        recoverCourse: `/course/recoverDeletedCourse`,
        updateCourse: `/course/updateProgress`,
    },
    subCategory: {
        createCategory: `/subCategory/createSubCategory`,
        getSubCategoriesById: `/subCategory/getSubCategoriesById`,
        deleteSubCategory: `/subCategory/deleteSubCategory`,
        editSubCategory: `/subCategory/editSubCategory`,
    },
    section: {
        createSection: `/section/create`,
        getSectionOfCourse: `/section/allSectionsOfCourse`,
        getIndividalSection: `/section`,
        editQuestion: `/section/editQuestion`,
        createQuestion: `/section/createQuestion`,
        getIndividualQuestion: `/section/getIndividualQuestion`,
        createLectureExcercise: `/lecture/createLectureExcercise`,
        getLectureExcercise: `/lecture/getLectureExcercise`,
        deleteLectureExcercise: `/lecture/deleteLectureExcercise`,
        delete: `/section/delete`,
        edit: `/section/edit`,
        getIndividalSection: `/section`,
        getAnswer: `/section/getAnswer`,
    },
    labs: {
        create: `/labs/create`,
        edit: `/labs/edit`,
        delete: `/labs/delete`,
        getIndividual: `/labs`,
    },
    users: {
        getAllStudents: `/user/getAllStudents`,
        getAllInstructors: `/user/getAllInstructors`,
        getAllAdmins: `/user/getAllAdmins`,
        getAllAssistants: `/user/getAllAssistants`,
        blockUser: `/user/blockUser`,
        unBlockUser: `/user/unBlockUser`,
    },
    message: {
        sendMessage: `/sms/msg`,
    },
    lecture: {
        createLecture: `/lecture/create`,
        editLecture: `/lecture/edit`,
        getIndividualLecture: `/lecture/getIndividualLecture`,
        delete: `/lecture/delete`,
        getCompletedLecturesOfCourse: `/lecture/getCompletedLecturesOfCourse`,
    },
    category: {
        createCategory: `/category/createCategory`,
        getAllCategories: `/category/getAllCategories`,
        deleteCategory: `/category/deleteCategory`,
        editCategory: `/category/editCategory`,
    },
    statistics: {
        getAdminDashStats: `/statistics/getAdminDashStats`,
        getUsersCount: `/statistics/getUsersCount`,
        getAllUsers: `/statistics/getAllUsers`,
    },
    request: {
        send: `/request/create`,
        findAllRequest: `/request/allRequestOfInstructor`,
        acceptRequest: `/request/acceptRequest`,
        declineRequest: `/request/declineRequest`,
        excelRequestAccept: `/request/excelrequestaccept`,
    },
    resource: {
        createResource: `/resourse/create`,
        editResource: `/resourse/edit`,
        deleteResource: `/resourse/delete`,
        images: `/resourse/images`,
    },
    circular: {
        createCircular: `/circular/create`,
        getCirculars: `/circular/getCirculars`,
        uploadCircularPdf: `/circular/uploadPdf`,
    },
    comments: {
        getComments: `/comment/getAllComments`,
        updateComment: `/comment/update`,
        replyToComment: `/comment/reply`,
        createComment: `/comment/create`,
        editReply: `/comment/editReply`,
    },
    ui: {
        changeLogo: `/logo/upload`,
        getLogo: `/logo/getLogo`,
    },
    poll: {
        createPoll: `/poll/create`,
        getPolls: `/poll/getPolls`,
        getVotesOfPoll: `/poll/getVotes`,
    },
    reviews: {
        getReview: `/review/get-review`,
    },
    likes: {
        likeLecture: `/likes/create`,
        getLikes: `/likes/getLikesofLecture`,
    },
    comments: {
        createComment: `/comment/create`,
        updateComment: `/comment/update`,
        getComments: `/comment/getAllComments`,
        replyToComment: `/comment/reply`,
        editReply: `/comment/editReply`,
    },
    survey: {
        createSurvey: `/survey/create`,
        getSurvey: `/survey/getAllSurveys`,
        getVotesOfSurvey: `/survey/getVotesOfSurvey`,
    },
    url,
};

export default Apiconfig;
